module.exports = __webpack_public_path__ + "screenshot_3.333d0d8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/DeveloperIntegration/Guides/screenshot_3.png
// module id = 3004
// module chunks = 0